import { GridItem } from '@zuto/core/src/grid'
import { ArrowRight } from '@zuto/icons'
import React, { useContext } from 'react'
import { SpaceProps } from 'styled-system'
import { fireReactGAEvent } from '../Questions/utils'
import CenteredButton from '../../style/CenteredCTA'
import { ApplicationFormContext } from '../ApplicationForm/ApplicationFormContext'
import styled from 'styled-components'
import { BaseAtLandingPageV6StyledProps } from '../Introductions/VehicleIntroduction/VehicleCard'
import Button from '@zuto/atoms/src/Mui/Button/Button'


type StartApplicationButtonProps = {
  children?: string
  position?: 'top' | 'bottom'
  size?: 'small' | 'medium' | 'large'
  isCentered?: boolean
  vehicleImg?: boolean
} & SpaceProps

const StartApplicationButton = (
  {
    children = 'Ok, let\'s go',
    position = 'top',
    isCentered = false,
    size = 'medium',
    vehicleImg,
    ...props
  }: StartApplicationButtonProps
): JSX.Element => {
  const { dispatch } = useContext(ApplicationFormContext)
  const { featureSwitches } = useContext(ApplicationFormContext)
  const { atLandingPageV5, atLandingPageV6 } = featureSwitches ?? {}

  type StyledGridItemProps = BaseAtLandingPageV6StyledProps
  
  const StyledGridItem = styled(GridItem)<StyledGridItemProps>`
    /* Hiding on mobile for atLandingPageV6 when vehicle image is present as this appears in a sticky box at the bottom of the screen */
    @media only screen and (max-width: 767px) {
      display: ${(props) => (props.$atLandingPageV6 && props.$vehicleImg ? 'none' : 'flex')};
    }
  `

  const handleStartButtonClick = () => {
    fireReactGAEvent({
      category: 'Application Form',
      action: 'CTA Clicked',
      label: `continue to next step – ${position}`
    })

    dispatch({
      type: 'QUESTION_ANSWERED',
      name: 'introduction',
      value: ''
    })
  }

  return (
    <>
      {isCentered ? (
        <StyledGridItem
          display="flex"
          alignItems="center"
          gridColumn={['1 / span 12', '7 / span 4']}
          gridRow={['auto', '5 / auto']}
          $atLandingPageV6={atLandingPageV6}
          $vehicleImg={vehicleImg}
          {...props}
        >
          <CenteredButton
            endSvgIcon={ArrowRight}
            onClick={handleStartButtonClick}
            disabled={false}
            data-testid="start-application-button-centered"
          >
            {atLandingPageV5 ? 'Check my eligibility' : children}
          </CenteredButton>
        </StyledGridItem>
      )
        : (
          <StyledGridItem gridColumn={['1 / span 12', '3 / span 8']} {...props}>
            <Button
              endSvgIcon={ArrowRight}
              size={size}
              onClick={handleStartButtonClick}
              data-testid="start-application-button"
            >
              {children}
            </Button>
          </StyledGridItem>
        )}
    </>
  )
}

export default StartApplicationButton
